// extracted by mini-css-extract-plugin
export default {"dialogBody":"UploadImagesDialog_dialogBody__+WEz2"};